import type { AccessibilitySnapshotArchive, Task } from "../../lib/types";

export function selectRelevantSnapshots(
  task: Task,
  snapshots: AccessibilitySnapshotArchive[],
  deviceIds: Set<string>,
) {
  const candidates = snapshots.filter((item) => deviceIds.has(item.deviceId));
  const exact = candidates.filter((item) => item.taskId === task.id);
  if (exact.length > 0) {
    return exact;
  }

  return task.results.flatMap((result) => {
    const finishedAt =
      result.finishedAt || result.acknowledgedAt || result.sentAt;
    const finishedTime = finishedAt
      ? new Date(finishedAt).getTime()
      : Number.NaN;
    const forDevice = candidates.filter(
      (item) => item.deviceId === result.deviceId,
    );
    if (!Number.isFinite(finishedTime)) {
      return forDevice.slice(0, 1);
    }
    const closest = [...forDevice].sort(
      (left, right) =>
        Math.abs(new Date(left.capturedAt).getTime() - finishedTime) -
        Math.abs(new Date(right.capturedAt).getTime() - finishedTime),
    )[0];
    if (!closest) {
      return [];
    }
    const difference = Math.abs(
      new Date(closest.capturedAt).getTime() - finishedTime,
    );
    return difference <= 5 * 60 * 1000 ? [closest] : [];
  });
}
